module.exports = __webpack_public_path__ + "img/arrow_green.e3203bf6.gif";